async function EductorSave (
    edcutorid, jobnumber, quotenumber, model, 
    datecompleted, testedbyid, approvedbyid, sketchnumber, 
    frequency, inletdiameter, outletdiameter, horsepower, 
    velocity, csprinducedairflow, csprinletstaticpressure, csprdischargestaticpressure, 
    bsprmanufacturermodel, bsprairflowcfm, bsprcalculatedbhp, bsprinletstaticpressure, 
    bsproutletstaticpressure, bsprpurchaseordernumber, bsprdatecompleted, 
    aprplenumpressure, aprnozzlesetting, aprstaticclosedoff, aprtight, 
    aprmotorrpm, aprmotorvoltage, aprcalculatedblowerairflow, aprplenumtype, 
    aprmotoramps1, aprmotoramps2, aprmotoramps3, aprmotorampsaverage, 
    aprmotorampsrated, notes, air_temperature, air_humidity, air_pressure, intakesilencer, aprmotornotes, suffix) {

    if (true) {

            let response;

            let params = {
                "@eductorID": edcutorid,
                "@jobNumber": jobnumber,
                "@quoteNumber": quotenumber,
                "@model": model,
                "@dateCompleted": datecompleted,
                "@testedByID": testedbyid,
                "@approvedByID": approvedbyid,
                "@sketchNumber": sketchnumber,
                "@frequency": frequency,
                "@inletDiameter": inletdiameter,
                "@outletDiameter": outletdiameter,
                "@horsepower": horsepower,
                "@velocity": velocity,
                "@CSPR_InducedAirFlow": csprinducedairflow,
                "@CSPR_InletStaticPressure": csprinletstaticpressure,
                "@CSPR_DischargeStaticPressure": csprdischargestaticpressure,
                "@BSPR_ManufacturerModel": bsprmanufacturermodel,
                "@BSPR_AirFlowCFM": bsprairflowcfm,
                "@BSPR_CalculatedBHP": bsprcalculatedbhp,
                "@BSPR_InletStaticPressure": bsprinletstaticpressure,
                "@BSPR_OutletStaticPressure": bsproutletstaticpressure,
                "@BSPR_PurchaseOrderNumber": bsprpurchaseordernumber,
                "@BSPR_DateCompleted": bsprdatecompleted,
                "@APR_PlenumPressure": aprplenumpressure,
                "@APR_NozzleSetting": aprnozzlesetting,
                "@APR_StaticClosedOff": aprstaticclosedoff,
                "@APR_Tight": aprtight,
                "@APR_MotorRPM": aprmotorrpm,
                "@APR_MotorVoltage": aprmotorvoltage,
                "@APR_CalculatedBlowerAirFlow": aprcalculatedblowerairflow,
                "@APR_PlenumType": aprplenumtype,
                "@APR_MotorAmps1": aprmotoramps1,
                "@APR_MotorAmps2": aprmotoramps2,
                "@APR_MotorAmps3": aprmotoramps3,
                "@APR_MotorAmpsAverage": aprmotorampsaverage,
                "@APR_MotorAmpsRated": aprmotorampsrated,
                "@Notes": notes,
                "@AirTemperature": air_temperature,
                "@Humidity": air_humidity,
                "@AirPressure": air_pressure,
                "@IntakeSilencer": intakesilencer,
                "@APR_MotorNotes": aprmotornotes,
                "@Suffix": suffix
              };

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "78", 
                    "parameters": params,
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return Promise.resolve(response);
    }
}
 
export default EductorSave;